// 引入axios方法
import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import {
  fun_CheckLockBrand,
  fun_ECCAInit,
  fun_GetExpirationDate,
  fun_GetLockNumber,
  fun_GetOrgId,
  fun_IsIe
} from "../../../utils/commonLock";
import {
  fun_LoadXSKeyInterface,
  fun_XSKeyFind,
  fun_XSKeyHID,
  fun_XSKeyAdminLogon,
  fun_XSKeyReadData,
  fun_XSKeyHmacMD5
} from "../../../utils/commonXsLock";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
import VueQr from "vue-qr";
// 引入加密方法
import "../../../utils/security.js";
import { Loading } from "element-ui";
export default {
  /**
   * 组件默认导出属性
   * @author 滕威
   */
  // 初始化数据
  data() {
    return {
      // 切换状态
      activeName: "1",
      // 企业登录切换
      activeRadio: "1",
      // 登录类型切换
      childTabs: ["账号登录", "CA登录"],
      // 切换提示信息
      tip: "CA互联登录时，须使用CA锁，并输入“验证码”即可登录。",
      loginUserType: null, // 用户登录类型
      phone: null, // 手机号
      // 图片路径对象
      codeImgSrc: null,
      // 全局加载
      fullLoading: null,
      key: null, // 加密key
      // 切换标签的钩子
      nametabPosition: "0",
      // 登陆对象
      label: "工作人员登录",
      // 选项卡所在位置
      tabPosition: "left",
      // 表单对象
      request: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        username: null, // 用户名
        password: null, // 密码
        smm: null, // 锁密码
        title: null, // 验证码
        t: null, // 随机数
        flag: null, // 登录类型(0:工作人员登录，1：账号密码登录，2：ca锁登录，3：扫码登录)
        wzbh: "201311080946010001", // 网站编号
        lockType: null, // 锁品牌类型验证
        certSn: null, // 锁编号
        legalCode: null, // 企业社会信用代码
        idCard: null, // 身份证号
        personName: null, // 用户名称
        telephoneNum: null, // 手机号
        serialNum: null, // 锁编号
        loginUserType: null // 扫码用户类型
      },
      form: {
        username: null, // 用户名
        password: null, // 密码
        title: null // 验证码
      },
      // 验证信息
      rules: {
        username: [
          {
            required: true,
            message: "请输入您在注册时填写的登录名",
            trigger: "blur"
          }
        ]
      },
      // 占位符
      userPlaceholder: "请输入您在注册时填写的登录名", // 用户名
      // 登录按钮loading状态
      loading: false,
      /****************************************标信通******************************************/
      // 标信通APP扫码  true为不显示  false为显示
      bxtStandardSignal: true,
      // 标信通APP扫码图片  true为不显示  false为显示
      bxtStandardSignalCode: false,
      // 二维码失效标志
      bxtQrFailFlag: false,
      // 标信扫码对象
      bxtQr: {
        // 二维码失效时间
        codeFailTime: null,
        // 定时任务对象
        intervalTime: null,
        // 扫码信息
        qrCode: null,
        // token
        token: null
      },
      // 标信二维码参数
      bxtCodeParam: {
        // 图片内容
        imgUrl: null,
        // logo地址
        logo: require("@/assets/images/bxtLogo.png")
      },
      /****************************************中招互联******************************************/
      // 中招互联APP扫码  true为不显示  false为显示
      zzStandardSignal: true,
      // 中招互联APP扫码图片  true为不显示  false为显示
      zzStandardSignalCode: false,
      // 二维码失效标志
      zzQrFailFlag: false,
      // 中招扫码对象
      zzQr: {
        // 二维码失效时间
        codeFailTime: null,
        // 定时任务对象
        intervalTime: null,
        // tid
        tid: null,
        // 二维码内容
        QRCodeContent: null,
        // 扫码信息
        qrCode: null
      },
      // 中招二维码参数
      zzCodeParam: {
        // 图片路径
        imgUrl: null,
        // logo地址
        logo: require("@/assets/images/zzLogo.png")
      },
      /****************************************标证通******************************************/
      // 标证通APP扫码  true为不显示  false为显示
      bztStandardSignal: true,
      // 标证通APP扫码图片  true为不显示  false为显示
      bztStandardSignalCode: false,
      // 标证通二维码失效标志
      bztQrFailFlag: false,
      // 标证通扫码对象
      bztQr: {
        // 二维码失效时间
        codeFailTime: null,
        // 定时任务对象
        intervalTime: null,
        // 扫码信息
        qrCode: null
      },
      // 标证通二维码参数
      bztCodeParam: {
        // 图片路径
        imgUrl: null,
        // logo路径
        logo: require("@/assets/images/bztLogo.png")
      },
      /****************************************电子营业执照******************************************/
      // 电子营业执照APP扫码  true为不显示  false为显示
      dzzzStandardSignal: true,
      // 电子营业执照APP扫码图片  true为不显示  false为显示
      dzzzStandardSignalCode: false,
      // 电子营业执照二维码失效标志
      dzzzQrFailFlag: false,
      // 电子营业执照扫码对象
      dzzzQr: {
        // 二维码失效时间
        codeFailTime: null,
        // 定时任务对象
        intervalTime: null,
        // 扫码信息
        qrCode: null
      },
      // 电子营业执照二维码参数
      dzzzCodeParam: {
        // 图片路径
        imgUrl: null,
        // logo路径
        logo: require("@/assets/images/dzzzLogo.png")
      },
      /****************************************全国共享二维码******************************************/
      // 全国共享二维码APP扫码  true为不显示  false为显示
      shareStandardSignal: true,
      // 全国共享二维码APP扫码图片  true为不显示  false为显示
      shareStandardSignalCode: false,
      // 全国共享二维码二维码失效标志
      shareQrFailFlag: false,
      // 全国共享二维码执照扫码对象
      shareQr: {
        // 二维码失效时间
        codeFailTime: null,
        // 定时任务对象
        intervalTime: null,
        // 扫码信息
        qrCode: null,
        // tid
        tid: null
      },
      // 全国共享二维码执照二维码参数
      shareCodeParam: {
        // 图片路径
        imgUrl: null
      },
      //全国互认获取二维码的信息
      shareQrCodeid: null,
      //二维码失效时间
      shareTime: null,
      // ca驱动url
      url: null,
      // 提示
      isTips: true,
      /***********工作人员登录，谷歌验证器************* */
      // 谷歌key值
      secretKey: null,
      // 身份验证器默认关闭
      dialogVisible: false,
      // 谷歌身份验证器二维码
      googleQrCodeImage: null,
      // 谷歌身份验证码
      googleCode: null,
      // 下载谷歌验证器
      downDialogVisible: false,
      // 判断标识
      keyFlag: "0",
      // 用户信息
      user: {
        // 用户编号
        id: null,
        // token
        token: null,
        // 真实姓名
        realName: null,
        // 用户标识
        userFlag: null
      },
      smFlag: true // 扫码轮询标记  防止网速卡导致上次回调还未返回就进行下次调用
    };
  },
  components: {
    VueQr
  },
  // 模板编译完成
  mounted() {
    // 获取浏览器地址参数
    const lt = this.$route.query.lt;
    // 如果存在参数
    if (lt) {
      // 自动切换
      this.activeName = lt;
    }
    // 调用获取参数方法
    this.fun_GetRSAKey();
    // 调用验证码方法
    this.fun_GetCode();
    // 获取ca驱动下载路径
    // this.fun_GetFilePath();
  },
  // 自定义事件
  methods: {
    /**
     * 获取验证码接口
     * @author 滕威
     */
    fun_GetCode() {
      // 获取随机数
      this.request.t = new Date().getTime();
      // 获取验证码
      this.codeImgSrc = `/brs-server/mime?t=${this.request.t}`;
    },
    /**
     * 下载方法
     */
    fun_GetFilePath() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "CA驱动"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 不退还申请表路径
          this.url = data;
        }
      });
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 获取参数接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.request.exponent = data.exponent;
          // 获取modulus
          this.request.modulus = data.modulus;
        }
      });
    },
    /**
     * 登录
     * @author 滕威
     */
    fun_SubmitForm() {
      // 如果是企业项目负责人登录
      if (this.activeName == "1") {
        // 企业登录
        this.fun_CorpLogin();
      }
      // 工作人员密码登录
      else if (this.activeName == "2") {
        // 工作人员登录
        // this.fun_RegistryLogin();
        this.fun_StaffLogin();
      }
    },
    /**
     * 企业登录
     */
    fun_CorpLogin() {
      // 设置登录类型
      this.request.flag = this.activeRadio;
      // 如果是账号密码登录
      if (this.activeRadio == "1") {
        // 校验
        this.$refs.form.validate(valid => {
          // 校验通过
          if (valid) {
            // 遮罩框加载
            this.fun_Loading();
            // 获取加密key
            this.key = window.RSAUtils.getKeyPair(
              this.request.exponent,
              "",
              this.request.modulus
            );
            // 遍历加密用户名、密码、验证码
            for (let e in this.form) {
              this.request[e] = window.RSAUtils.encryptedString(
                this.key,
                this.form[e]
              );
            }
            // 登录
            this.fun_Login("0");
            // 打开loading状态
            this.loading = true;
          } else {
            // 加载框取消
            // this.fullLoading.close();
            // 关闭loading状态
            this.loading = false;
            // 校验不通过，返回false，页面给出提示
            return false;
          }
        });
      }
      // ca锁登录
      else if (this.activeRadio == "2") {
        // 校验
        this.$refs.form.validate(valid => {
          // 校验通过
          if (valid) {
            // 遮罩框加载
            this.fun_Loading();
            // 获取加密key
            this.key = window.RSAUtils.getKeyPair(
              this.request.exponent,
              "",
              this.request.modulus
            );
            // 遍历加密用户名、密码、验证码
            for (let e in this.form) {
              // 不为空时
              if (this.form[e] != "" && this.form[e] != null) {
                this.request[e] = window.RSAUtils.encryptedString(
                  this.key,
                  this.form[e]
                );
              }
            }
            // ca锁登录
            this.fun_CaLogin();
            // 打开loading状态
            this.loading = false;
          } else {
            // 加载框取消
            // this.fullLoading.close();
            // 关闭loading状态
            this.loading = false;
            // 校验不通过，返回false，页面给出提示
            return false;
          }
        });
      }
      // 扫码登录
      else {
        // 遮罩框加载
        this.fun_Loading();
        // 登录
        this.fun_Login("0");
      }
    },
    /**
     * ca锁登录
     */
    fun_CaLogin() {
      // 打开loading状态
      this.loading = true;
      // 初始化
      fun_IsIe();
      // 控件初始化
      if (!fun_ECCAInit()) {
        // 关闭loading状态
        this.loading = false;
        // 加载框取消
        this.fullLoading.close();
        // 校验不通过，返回false，页面给出提示
        return false;
      }
      // CA自动检测
      let lockBrand = fun_CheckLockBrand();
      // 信达汇格
      if (
        lockBrand != "201512281800580005" &&
        lockBrand != "201708031617450366" && // 中金CA
        lockBrand != "201811291813450004" && // 湖北CA
        lockBrand != "201512281800350004"
      ) {
        // 颐信科技
        // 加载框取消
        this.fullLoading.close();
        // 关闭loading状态
        this.loading = false;
        // 校验不通过，返回false，页面给出提示
        return false;
      }
      // 锁编号
      let lockNo = fun_GetLockNumber();
      // 证书到期日
      let expirationDate = fun_GetExpirationDate();
      // 获取组织机构代码
      let orgCd = fun_GetOrgId();
      // 调用登录接口
      fun_PostAction("/userLogin/checkCaLogin", {
        ...this.request,
        lockNo: lockNo,
        lockBrand: lockBrand,
        expirationDate: expirationDate,
        orgCd: orgCd
      }).then(res => {
        const { result, data, msg } = res.data;
        // 回调
        if (result) {
          // 设置用户名称
          this.request.username = data.encodedOrgCd;
          // 登录
          this.fun_Login("0");
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 关闭loading状态
          this.loading = false;
          // 登录失败给出提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 登录方法（0：企业登录，1：工作人员登录）
     */
    fun_Login(e) {
      // 调用登录接口
      fun_PostAction("/userLogin/login", { ...this.request }).then(res => {
        const { result, data } = res.data;
        // 回调
        if (result) {
          if (data.passwordMsg) {
            // 错误提示
            this.$message.info(data.passwordMsg);
          }
          // 登录成功添加token到vuex
          this.$store.commit("SET_TOKEN", data.token);
          this.$store.commit("SET_USERINFO", data.realName);
          this.$store.commit("SET_LOGINTYPE", data.loginType);
          this.$store.commit("SET_USERTYPE", data.userType);
          this.$store.commit("SET_USERFLAG", data.userFlag);
          this.$store.commit("SET_PROJECT", "brs");
          // 跳往首页
          this.$router.push({
            path: "/home"
          });
        } else {
          // 登录失败给出提示
          this.$message.error(res.data.msg);
          // 刷新验证码
          this.fun_GetCode();
          // 关闭loading状态
          this.loading = false;
          // 清空验证码输入框
          this.form.title = null;
        }
        // 加载框取消
        this.fullLoading.close();
      });
    },
    /**
     * 工作人员登录
     */
    fun_RegistryLogin() {
      // 遮罩框加载
      this.fun_Loading();
      // 设置登录类型
      this.request.flag = "0";
      // 校验
      this.$refs.form.validate(valid => {
        // 校验通过
        if (valid) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(
            this.request.exponent,
            "",
            this.request.modulus
          );
          // 遍历加密用户名、密码、验证码
          for (let e in this.form) {
            this.request[e] = window.RSAUtils.encryptedString(
              this.key,
              this.form[e]
            );
          }
          // 电子锁页面初始化
          fun_LoadXSKeyInterface();
          // 查找密保锁
          let securityLockCnt = fun_XSKeyFind();
          // 加密狗数量为零的场合
          if (securityLockCnt == 0) {
            // 请求失败，提示信息
            this.$message.error("未插入工作人员密保锁！");
            // 加载框取消
            this.fullLoading.close();
            return false;
          }
          // 硬件号
          let keyHID = fun_XSKeyHID();
          // 设置锁编号
          this.request.serialNum = window.RSAUtils.encryptedString(
            this.key,
            keyHID
          );
          // 发起请求，获取结果集
          fun_PostAction("/userLogin/xsLogin", {
            username: this.request.username,
            serialNum: this.request.serialNum
          }).then(res => {
            // 解构res.data
            const { result, data } = res.data;
            // 判断请求是否成功
            if (result) {
              // 锁管理员登录
              let msg = fun_XSKeyAdminLogon(data);
              // 存在错误的场合
              if (msg != "") {
                // 加载框取消
                this.fullLoading.close();
                // 请求失败，提示信息
                this.$message.error(msg);
                return false;
              } else {
                // 锁内容读取
                let snr = fun_XSKeyReadData();
                // MD5密码
                let md5Password = fun_XSKeyHmacMD5(snr);
                // 设置锁密码
                this.request.smm = snr + ";" + md5Password;
                // 登录
                this.fun_Login("1");
              }
            } else {
              // 加载框取消
              this.fullLoading.close();
              // 请求失败，提示信息
              //this.$message.error("密保锁认证失败！请插入对应的密保锁！");
              return false;
            }
          });
        } else {
          // 加载框取消
          // this.fullLoading.close();
          // 校验不通过，返回false，页面给出提示
          return false;
        }
      });
    },
    /**
     * 注册
     * @author 滕威
     */
    fun_UserReg() {
      // 跳转
      window.open("https://www.whzbtbxt.cn/whebd/#/register");
    },
    /**
     * 忘记密码
     * @author 滕威
     */
    fun_ForgetPassword() {
      // 跳转
      this.$router.push({ path: "/forgetThePassword" });
    },
    /**
     * 切换tabs
     * @author 小刘
     * @param {tab} 导航栏
     */
    fun_GetHandleClick(tab) {
      // 判断是否切换
      if (this.activeName !== tab) {
        // 切换
        this.activeName = tab;
        // 切换时清空form表单
        for (let i in this.form) {
          // 清空
          this.form[i] = null;
        }
        this.$nextTick(() => {
          // 清除表单验证和数据
          if (this.$refs.form) this.$refs.form.resetFields();
        });
        // 还原企业切换
        this.activeRadio = "1";
        // 判断切换值
        if (tab === "1") {
          // 切换为企业时
          // 更换占位符
          this.userPlaceholder = "请输入您在注册时填写的登录名";
          // 更换验证消息
          this.rules.username = [
            {
              required: true,
              message: "请输入您在注册时填写的登录名",
              trigger: "blur"
            }
          ];
        } else {
          // 切换为工作人员时
          // 更换占位符
          this.userPlaceholder = "请输入您的用户名";
          // 更换验证消息
          this.rules.username = [
            {
              required: true,
              message: "请输入您的用户名",
              trigger: "blur"
            }
          ];
        }
      }
    },
    /**
     * 切换登录方式
     */
    fun_GetActiveRadio(e) {
      // 获取下标
      this.activeRadio = e;
      // 如果是密码登录或者ca登录
      if (e == "1" || e == "2") {
        // 切换时清空form表单
        for (let i in this.form) {
          // 清空
          this.form[i] = null;
        }
        this.$nextTick(() => {
          // 清除表单验证和数据
          if (this.$refs.form) this.$refs.form.clearValidate();
        });
        // // 标信通APP扫码  true为显示  false不为显示
        // this.bxtStandardSignal = true;
        // // 标信通APP扫码图片  true为显示  false不为显示
        // this.bxtStandardSignalCode = false;
        // // 中招互联APP扫码  true为显示  false不为显示
        // this.zzStandardSignal = true;
        // // 中招互联APP扫码图片  true为显示  false不为显示
        // this.zzStandardSignalCode = false;
        // // 标证通App扫码  true为显示  false不为显示
        // this.bztStandardSignal = true;
        // // 标证通APP扫码图片  true为显示  false不为显示
        // this.bztStandardSignalCode = false;
        // // 电子营业执照扫码  true为显示  false不为显示
        // this.dzzzStandardSignal = true;
        // // 电子营业执照扫码图片  true为显示  false不为显示
        // this.dzzzStandardSignalCode = false;
        // 全国互认扫码  true为显示  false不为显示
        this.shareStandardSignal = true;
        // 全国互认扫码图片  true为显示  false不为显示
        this.shareStandardSignalCode = false;
        // 取消定时任务
        this.fun_ClearInter();
      } else if (e === "3") {
        // 显示中招二维码
        this.fun_ShareCodeSignalShow();
      }
    },
    /**
     * 取消定时任务
     * @author
     */
    fun_ClearInter() {
      // // 标证通停止定时任务
      // clearInterval(this.bztQr.intervalTime);
      // // 标证通停止二维码失效任务
      // clearTimeout(this.bztQr.codeFailTime);
      // // 中招互连停止定时任务
      // clearInterval(this.zzQr.intervalTime);
      // // 中招互连停止二维码失效任务
      // clearTimeout(this.zzQr.codeFailTime);
      // // 标信通停止定时任务
      // clearInterval(this.bxtQr.intervalTime);
      // // 标信通停止二维码失效任务
      // clearTimeout(this.bxtQr.codeFailTime);
      // // 电子营业执照停止定时任务
      // clearInterval(this.dzzzQr.intervalTime);
      // // 电子营业执照停止二维码失效任务
      // clearTimeout(this.dzzzQr.codeFailTime);
      // 全国互认停止定时任务
      clearInterval(this.shareQr.intervalTime);
      // 全国互认停止二维码失效任务
      clearTimeout(this.shareQr.codeFailTime);
    },
    /**
     * 下载方法
     */
    fun_GetDol() {},
    /*************************************标信通**************************************/
    /**
     * 点击图片显示二维码  标信通
     * @author panmin
     */
    fun_BxtCodeSignalShow() {
      // 标信通APP扫码 隐藏   true为不显示  false为显示  取反
      this.bxtStandardSignal = !this.bxtStandardSignal;
      // 标信通APP扫码图片显示  true为不显示  false为显示  取反
      this.bxtStandardSignalCode = !this.bxtStandardSignalCode;
      // 中招互联APP扫码  隐藏   true为不显示  false为显示  取反
      this.zzStandardSignal = !this.zzStandardSignal;
      // 标证通App扫码隐藏，true为不显示，false为显示，取反
      this.bztStandardSignal = !this.bztStandardSignal;
      // 电子营业执照扫码隐藏，true为不显示，false为显示，取反
      this.dzzzStandardSignal = !this.dzzzStandardSignal;
      // 刷新标信通二维码
      this.fun_BxtRefCode();
    },
    /**
     * 刷新标信通二维码
     */
    fun_BxtRefCode() {
      // 停止定时任务
      clearInterval(this.bxtQr.intervalTime);
      // 停止二维码失效任务
      clearTimeout(this.bxtQr.codeFailTime);
      // 生成标信通二维码
      this.fun_GetBxtCodeContent("1");
      // 二维码失效
      this.bxtQrFailFlag = false;
    },
    /**
     * 获取标信通二维码内容
     * @author
     */
    fun_GetBxtCodeContent(qrCodeType) {
      // 执行请求
      fun_PostAction(
        "/ApplyQrCode/GetApplyQrCodeContent?qrCodeType=" +
          qrCodeType +
          "&rand=" +
          new Date().getTime()
      ).then(res => {
        // 解构res.data
        const { data } = res.data;
        // 执行成功，请求存在返回值
        if (data) {
          // 生成二维码
          this.bxtCodeParam.imgUrl = data.qrCodePath;
          // 如果二维码不为空
          if (data.qrCodePath) {
            // 设置扫码信息
            this.bxtQr.qrCode = data.qrCode;
            // 设置定时任务检验扫码状态
            this.bxtQr.intervalTime = setInterval(() => {
              this.fun_GetBxtQueryQrStatus();
            }, data.codeFlushTime);
            // 定时执行时效任务，30秒二维码时效
            this.bxtQr.codeFailTime = setTimeout(() => {
              this.fun_SetBxtFileCodeImage();
            }, data.codeFailTime);
          }
        }
      });
    },
    /**
     * 修改标信通失效二维码
     * @author zhouzhou
     */
    fun_SetBxtFileCodeImage() {
      // 二维码失效
      this.bxtQrFailFlag = true;
      // 取消定时任务
      clearInterval(this.bxtQr.intervalTime);
    },
    /**
     * 获取授权状态
     * @author zhouzhou
     */
    fun_GetBxtQueryQrStatus() {
      // 发送ajax请求
      fun_PostAction(
        "/ApplyQrCode/GetQueryQrStatus?rand=" + new Date().getTime(),
        { qrCode: this.bxtQr.qrCode }
      ).then(res => {
        // 解构res.data
        const { data } = res.data;
        // 请求成功
        if ("3" == data.qrCodeStatus) {
          // 设置客户端密匙
          this.bxtQr.token = data.token;
          // 获取用户详细信息（企业，个人）
          this.fun_GetUserInfoDetail(
            data.userIdentity,
            data.openId,
            data.token
          );
        }
        // 二维码已失效
        else if ("5" == data.qrCodeStatus) {
          // 修改标信通失效二维码
          this.fun_SetBxtFileCodeImage();
        }
      });
    },
    /**
     * 获取用户详细信息（企业，个人）数据
     * @author
     */
    fun_GetUserInfoDetail(userIdentity, openId, token) {
      // 发送ajax请求
      fun_PostAction(
        "/ApplyQrCode/GetUserInfoDetail?rand=" + new Date().getTime(),
        { userIdentity: userIdentity, token: token, openId: openId }
      ).then(res => {
        // 解构res.data
        const { data } = res.data;
        // 请求成功
        if (data.legalCode != null && data.legalCode != "") {
          // 修改为失效二维码
          this.fun_SetBxtFileCodeImage();
          // 停止二维码失效任务
          clearTimeout(this.bxtQr.codeFailTime);
          // 设置企业信用代码
          this.request.legalCode = data.legalCode;
          // 设置身份证
          this.request.idCard = data.idCard;
          // 用户名称
          this.request.personName = data.personName;
          // 手机号码
          this.request.telephoneNum = data.telephoneNum;
          // 锁编号
          this.request.certSn = data.serialNum;
          // 扫码用户类型
          this.request.loginUserType = data.loginUserType;
          // 锁品牌验证类型
          this.request.lockType = "130";
          // 登录
          this.fun_CorpLogin();
        } else {
          // 刷新标信通二维码
          this.fun_BxtRefCode();
        }
      });
    },
    /*************************************中招互连**************************************/
    /**
     * 点击图片显示二维码  中招互连
     * @author panmin
     */
    fun_ZzCodeSignalShow() {
      // 中招互联APP扫码  隐藏   true为不显示  false为显示  取反
      this.zzStandardSignal = !this.zzStandardSignal;
      // 中招互联APP扫码图片显示  true为不显示  false为显示  取反
      this.zzStandardSignalCode = !this.zzStandardSignalCode;
      // 标信通APP扫码 隐藏   true为不显示  false为显示  取反
      this.bxtStandardSignal = !this.bxtStandardSignal;
      // 标证通App扫码隐藏，true为不显示，false为显示，取反
      this.bztStandardSignal = !this.bztStandardSignal;
      // 电子营业执照扫码隐藏，true为不显示，false为显示，取反
      this.dzzzStandardSignal = !this.dzzzStandardSignal;
      // 刷新中招互连二维码
      this.fun_ZzRefCode();
    },
    /**
     * 刷新标中招互连二维码
     */
    fun_ZzRefCode() {
      // 停止定时任务
      clearInterval(this.zzQr.intervalTime);
      // 停止二维码失效任务
      clearTimeout(this.zzQr.codeFailTime);
      // 生成二维码
      this.fun_GetZzCodeContent();
      // 二维码失效
      this.zzQrFailFlag = false;
    },
    /**
     * 生成中招二维码
     */
    fun_GetZzCodeContent() {
      // 访问接口
      fun_PostAction("/interlink/getQRCodeContent").then(res => {
        const { data, result } = res.data;
        if (result) {
          // 二维码code
          this.zzQr.qrCode = data.qrCode;
          // 请求二维码tid
          this.zzQr.tid = data.tid;
          // 二维码内容
          this.zzQr.QRCodeContent = data.content;
          // 请求二维码
          this.zzCodeParam.imgUrl =
            "/whebd-server/interlink/getLoginQRCode?content=" + data.content;
          // 如果二维码不为空
          if (this.zzCodeParam.imgUrl) {
            // 设置定时任务检验扫码状态
            this.zzQr.intervalTime = setInterval(() => {
              this.fun_GetZzQueryQrStatus();
            }, data.codeFlushTime);
            // 定时执行时效任务，30秒二维码时效
            this.zzQr.codeFailTime = setTimeout(() => {
              this.fun_SetZzFileCodeImage();
            }, data.codeFailTime);
          }
        }
      });
    },
    /**
     * 修改中招互连失效二维码
     * @author zhouzhou
     */
    fun_SetZzFileCodeImage() {
      // 二维码失效
      this.zzQrFailFlag = true;
      // 取消定时任务
      clearInterval(this.zzQr.intervalTime);
    },
    /**
     * 校验扫码状态（中招互联）
     */
    fun_GetZzQueryQrStatus() {
      // 访问接口
      fun_PostAction("/interlink/checkQRCodeStatus", {
        tId: this.zzQr.tid
      }).then(res => {
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 返回数据不为空
          if (
            data.id != null &&
            data.id != "" &&
            ((data.legalCode != null && data.legalCode != "") ||
              (data.idCard != null && data.idCard != ""))
          ) {
            // 修改为失效二维码
            this.fun_SetZzFileCodeImage();
            // 停止二维码失效任务
            clearTimeout(this.zzQr.codeFailTime);
            // 设置企业信用代码
            this.request.legalCode = data.legalCode;
            // 设置身份证
            this.request.idCard = data.idCard;
            // 用户名称
            this.request.personName = data.personName;
            // 手机号码
            this.request.telephoneNum = data.phone;
            // 锁编号
            this.request.certSn = data.serialNum;
            // 扫码用户类型
            this.request.loginUserType = data.loginUserType;
            // 锁品牌验证类型
            this.request.lockType = "131";
            // 登录
            this.fun_CorpLogin();
          }
        }
      });
    },
    /*************************************标证通**************************************/
    /**
     * 点击图片显示二维码  标证通
     * @author panmin
     */
    fun_BztCodeSignalShow() {
      // 标证通App扫码隐藏，true为不显示，false为显示，取反
      this.bztStandardSignal = !this.bztStandardSignal;
      // 标证通APP扫码图片显示  true为不显示  false为显示  取反
      this.bztStandardSignalCode = !this.bztStandardSignalCode;
      // 标信通APP扫码 隐藏   true为不显示  false为显示  取反
      this.bxtStandardSignal = !this.bxtStandardSignal;
      // 中招互联APP扫码  隐藏   true为不显示  false为显示  取反
      this.zzStandardSignal = !this.zzStandardSignal;
      // 电子营业执照扫码隐藏，true为不显示，false为显示，取反
      this.dzzzStandardSignal = !this.dzzzStandardSignal;
      // 刷新标证通二维码
      this.fun_BztRefCode();
    },
    /**
     * 刷新标证通二维码
     */
    fun_BztRefCode() {
      // 停止定时任务
      clearInterval(this.bztQr.intervalTime);
      // 停止二维码失效任务
      clearTimeout(this.bztQr.codeFailTime);
      // 生成二维码
      this.fun_GetBztCodeContent("1");
      // 二维码失效
      this.bztQrFailFlag = false;
    },
    /**
     * 生成二维码
     */
    fun_GetBztCodeContent(qrCodeType) {
      // 访问接口
      fun_PostAction("/newPoint/getBztQRCodeContent", {
        qrCodeType: qrCodeType
      }).then(res => {
        const { data, result } = res.data;
        if (result) {
          // 设置二维码图片
          this.bztCodeParam.imgUrl =
            "data:image/Jpeg;base64," + data.qrCodePath; // content
          // 设置二维码字符串
          this.bztQr.qrCode = data.qrCodId;
          // 如果二维码不为空
          if (data.qrCodePath) {
            // 设置定时任务检验扫码状态
            this.bztQr.intervalTime = setInterval(() => {
              this.fun_GetBztQueryQrStatus();
            }, data.codeFlushTime);
            // 定时执行时效任务，30秒二维码时效
            this.bztQr.codeFailTime = setTimeout(() => {
              this.fun_SetBztFileCodeImage();
            }, data.codeFailTime);
          }
        }
      });
    },
    /**
     * 修改失效二维码
     * @author zhouzhou
     */
    fun_SetBztFileCodeImage() {
      // 二维码失效
      this.bztQrFailFlag = true;
      // 取消定时任务
      clearInterval(this.bztQr.intervalTime);
    },
    /**
     * 获取标证通授权状态
     */
    fun_GetBztQueryQrStatus() {
      // 访问接口
      fun_PostAction("/newPoint/getBztQueryStatus", {
        qrCodeId: this.bztQr.qrCode
      }).then(res => {
        const { data, result } = res.data;
        if (result) {
          // 如果授权成功
          if ("02" == data.qrCodeStatus) {
            // 修改为失效二维码
            this.fun_SetBztFileCodeImage();
            // 停止二维码失效
            clearTimeout(this.bztQr.codeFailTime);
            // 设置企业信用代码
            this.request.legalCode = data.legalCode;
            // 设置身份证
            this.request.idCard = data.idCard;
            // 用户名称
            this.request.personName = data.personName;
            // 手机号码
            this.request.telephoneNum = data.telephoneNum;
            // 锁编号
            this.request.certSn = data.dognum;
            // 扫码用户类型
            this.request.loginUserType = data.loginUserType;
            // 登录
            this.fun_CorpLogin();
          }
        }
      });
    },
    /*************************************电子营业执照**************************************/
    /**
     * 点击图片显示二维码  电子营业执照
     * @author panmin
     */
    fun_DzzzCodeSignalShow() {
      // 电子营业执照扫码隐藏，true为不显示，false为显示，取反
      this.dzzzStandardSignal = !this.dzzzStandardSignal;
      // 电子营业执照扫码图片显示  true为不显示  false为显示  取反
      this.dzzzStandardSignalCode = !this.dzzzStandardSignalCode;
      // 标信通APP扫码 隐藏   true为不显示  false为显示  取反
      this.bxtStandardSignal = !this.bxtStandardSignal;
      // 中招互联APP扫码  隐藏   true为不显示  false为显示  取反
      this.zzStandardSignal = !this.zzStandardSignal;
      // 标证通App扫码隐藏，true为不显示，false为显示，取反
      this.bztStandardSignal = !this.bztStandardSignal;
      // 刷新电子营业执照二维码
      this.fun_DzzzRefCode();
    },
    /**
     * 刷新电子营业执照二维码
     */
    fun_DzzzRefCode() {
      // 停止定时任务
      clearInterval(this.dzzzQr.intervalTime);
      // 停止二维码失效任务
      clearTimeout(this.dzzzQr.codeFailTime);
      // 生成二维码
      this.fun_GetDzzzCodeContent("login");
      // 二维码失效
      this.dzzzQrFailFlag = false;
    },
    /**
     * 生成二维码
     */
    fun_GetDzzzCodeContent(type) {
      // 访问接口
      fun_PostAction("/electronicCertificate/getQrCodeContent", {
        type: type
      }).then(res => {
        const { data, result } = res.data;
        if (result) {
          // 设置二维码图片
          this.dzzzCodeParam.imgUrl = "data:image/Jpeg;base64," + data.qrimage; // content
          // 设置二维码字符串
          this.dzzzQr.qrCode = data.qrid;
          // 如果二维码不为空
          if (data.qrimage) {
            // 设置定时任务检验扫码状态
            this.dzzzQr.intervalTime = setInterval(() => {
              this.fun_GetDzzzQueryQrStatus();
            }, data.codeFlushTime);
            // 定时执行时效任务，30秒二维码时效
            this.dzzzQr.codeFailTime = setTimeout(() => {
              this.fun_SetDzzzFileCodeImage();
            }, data.codeFailTime);
          }
        }
      });
    },
    /**
     * 修改失效二维码
     * @author zhouzhou
     */
    fun_SetDzzzFileCodeImage() {
      // 二维码失效
      this.dzzzQrFailFlag = true;
      // 取消定时任务
      clearInterval(this.dzzzQr.intervalTime);
    },
    /**
     * 扫码状态
     */
    fun_GetDzzzQueryQrStatus() {
      // 访问接口
      fun_PostAction("/electronicCertificate/getQueryQrStatus", {
        type: "login",
        qrid: this.dzzzQr.qrCode
      }).then(res => {
        const { data, result } = res.data;
        if (result) {
          // 如果授权成功
          if ("02" == data.data.qrCodeStatus) {
            // 修改为失效二维码
            this.fun_SetDzzzFileCodeImage();
            // 停止二维码失效
            clearTimeout(this.dzzzQr.codeFailTime);
            // 设置企业信用代码
            this.request.legalCode = data.data.uniscid;
            // 用户名称
            this.request.personName = data.data.entname;
            // 锁编号
            this.request.certSn = data.data.licencesn;
            // 扫码用户类型
            this.request.loginUserType = data.data.loginUserType;
            // 登录
            this.fun_CorpLogin();
          }
        }
      });
    },
    /*************************************全国互认**************************************/
    /**
     * 点击图片显示二维码  全国互认
     * @author panmin
     */
    fun_ShareCodeSignalShow() {
      // 刷新全国互认二维码
      this.fun_ShareRefCode();
    },
    /**
     * 刷新全国互认二维码
     */
    fun_ShareRefCode() {
      // 停止定时任务
      clearInterval(this.shareQr.intervalTime);
      // 停止二维码失效任务
      clearTimeout(this.shareQr.codeFailTime);
      // 生成二维码
      this.fun_GetShareCodeContent();
      // 二维码失效
      this.shareQrFailFlag = false;
    },
    /**
     * 生成全国互认二维码
     */
    fun_GetShareCodeContent() {
      // 访问接口
      fun_PostAction("/caShared/getLoginQRCode").then(res => {
        const { data, result, msg } = res.data;
        if (result) {
          // 请求二维码tid
          this.shareQr.tid = data.tid;
          // 二维码内容
          this.shareCodeParam.imgUrl = "data:image/Jpeg;base64," + data.content;
          // 设置二维码字符串
          this.shareQr.qrCode = data.content;
          // 如果二维码不为空
          if (data.content) {
            // 轮询时间
            this.shareTime = data.codeFlushTime;
            // 设置定时任务检验扫码状态
            this.shareQr.intervalTime = setInterval(() => {
              this.fun_GetShareQueryQrStatus();
            }, this.shareTime);
            // 定时执行时效任务，30秒二维码时效
            this.shareQr.codeFailTime = setTimeout(() => {
              this.fun_SetShareFileCodeImage();
            }, data.codeFailTime);
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 修改全国互认失效二维码
     * @author zhouzhou
     */
    fun_SetShareFileCodeImage() {
      // 二维码失效
      this.shareQrFailFlag = true;
      // 取消定时任务
      clearInterval(this.shareQr.intervalTime);
    },
    /**
     * 校验扫码状态（全国互认）
     */
    fun_GetShareQueryQrStatus() {
      // 允许轮询
      if (this.smFlag) {
        // 调用前设置为不允许 防止返回太慢下次轮询开始时上次轮询返回值未返回。
        this.smFlag = false;
        // 访问接口
        fun_PostAction("/caShared/getScanStatus", {
          tId: this.shareQr.tid
        }).then(res => {
          const { result, data, msg } = res.data;
          // 操作成功
          if (result) {
            // 设置为允许
            this.smFlag = true;
            // 查询不为空
            if (data && data.result) {
              // 授权成功
              if ("03" == data.scannedStatus) {
                // 修改为失效二维码
                this.fun_SetShareFileCodeImage();
                // 获取用户信息
                this.fun_GetShareUserAuthInfo(data.tid);
                // 已失效
              } else if ("02" == data.scannedStatus) {
                // 修改为失效二维码
                this.fun_SetShareFileCodeImage();
              }
            }
          }
        });
      }
    },
    /**
     * 获取用户信息
     */
    fun_GetShareUserAuthInfo(shareQrCodeid) {
      // 访问接口
      fun_PostAction("/caShared/getUserAuthInfo", {
        tId: shareQrCodeid,
        wzbh: "201311080946010001"
      }).then(res => {
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 查询不为空
          if (data && data.result) {
            // tid
            this.shareQrCodeid = data.tid;
            // 登录用户类型
            const loginUserType = data.loginUserType;
            // 锁编号
            const certSn = data.signatureCertSn;
            // 组织机构代码不为空
            if (data.orgCode) {
              // 修改为失效二维码
              this.fun_SetShareFileCodeImage();
              // 停止二维码失效
              clearTimeout(this.shareQr.codeFailTime);
              // 设置企业信用代码
              this.request.legalCode = data.orgCode;
              // 用户名称
              this.request.personName = data.personalName;
              // 手机号码
              this.request.telephoneNum = data.telephoneNumber;
              // 锁编号
              this.request.certSn = data.signatureCertSn;
              // 扫码用户类型
              this.request.loginUserType = data.loginUserType;
              // 锁品牌验证类型
              this.request.lockType = "131";
              // 登录
              this.fun_CorpLogin();
            } else {
              // 个人唯一ID
              const transactionCode = data.personalTransactionCode;
              // 身份证号hash
              const idCardHash = data.idCardHash;
              // 解析获取身份证信息
              this.fun_ShareAnalysisSignCert(
                data.signatureCert,
                loginUserType,
                data.personalName,
                data.telephoneNumber,
                certSn,
                this.shareQrCodeid,
                transactionCode,
                idCardHash
              );
            }
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 解析身份证号
     */
    fun_ShareAnalysisSignCert(
      signatureCert,
      loginUserType,
      personalName,
      telephoneNumber,
      certSn,
      shareQrCodeid,
      transactionCode,
      idCardHash
    ) {
      // 访问接口
      fun_PostAction("/caShared/analysisSignCert", {
        signatureCert: signatureCert,
        loginUserType: loginUserType,
        tid: shareQrCodeid,
        transactionCode: transactionCode,
        idCardHash: idCardHash,
        signatureCertSn: certSn,
        personalName: personalName,
        telephoneNumber: telephoneNumber,
        wzbh: "201311080946010001"
      }).then(res => {
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 查询不为空
          if (data && data.result) {
            // 修改为失效二维码
            this.fun_SetShareFileCodeImage();
            // 停止二维码失效
            clearTimeout(this.shareQr.codeFailTime);
            // 设置身份证
            this.request.idCard = data.data;
            // 用户名称
            this.request.personName = personalName;
            // 手机号码
            this.request.telephoneNum = telephoneNumber;
            // 锁编号
            this.request.certSn = certSn;
            // 扫码用户类型
            this.request.loginUserType = loginUserType;
            // 锁品牌验证类型
            this.request.lockType = "131";
            // 登录
            this.fun_CorpLogin();
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "登录中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 关闭提示
     * @author 滕威
     */
    fun_CloseTip() {
      // 隐藏提示
      this.isTips = false;
    },

    /*****************************工作人员登录，谷歌验证器*************************** */

    /**
     * 工作人员登录
     */
    fun_StaffLogin() {
      // 遮罩框加载
      this.fun_Loading();
      // 校验
      this.$refs.form.validate(valid => {
        // 校验通过
        if (valid) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(
            this.request.exponent,
            "",
            this.request.modulus
          );
          // 遍历加密用户名、密码、验证码
          for (let e in this.form) {
            this.request[e] = window.RSAUtils.encryptedString(
              this.key,
              this.form[e]
            );
          }
          // 发起请求
          fun_PostAction("/userLogin/staffLogin", {
            ...this.request
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 操作成功
            if (result) {
              if (data.passwordMsg) {
                // 错误提示
                this.$message.info(data.passwordMsg);
              }
              // 关闭遮罩
              this.fullLoading.close();
              // 谷歌key值
              this.secretKey = data.secretKey;
              // 用户编号
              this.user = data;
              // 通过谷歌验证器验证
              if (data.googleVerify === "true") {
                // 没有注册过谷歌验证
                if (!this.secretKey) {
                  // 修改标识
                  this.keyFlag = "1";
                  // 获取二维码
                  this.fun_GetGoogleQrCode();
                } else {
                  // 修改标识
                  this.keyFlag = "0";
                  // 打开弹窗
                  this.dialogVisible = true;
                }
              } else {
                // 登录成功添加token到vuex
                this.$store.commit("SET_TOKEN", this.user.token);
                this.$store.commit("SET_USERINFO", this.user.realName);
                this.$store.commit("SET_USERFLAG", this.user.userFlag);
                this.$store.commit("SET_PROJECT", "brs");
                // 跳往首页
                this.$router.push({
                  path: "/home"
                });
              }
            } else {
              // 关闭遮罩
              this.fullLoading.close();
              // 错误提示
              this.$message.error(msg);
            }
          });
        } else {
          // 关闭遮罩
          this.fullLoading.close();
        }
      });
    },

    /**
     * 获取谷歌身份验证器绑定二维码
     * @author shuhua
     */
    fun_GetGoogleQrCode() {
      // 发起请求
      fun_PostAction("/userLogin/getGoogleQrCode", {
        username: this.form.username
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 二维码
          this.googleQrCodeImage = "data:image/Jpeg;base64," + data.url;
          // 谷歌验证key
          this.secretKey = data.secretKey;
          // 打开弹窗
          this.dialogVisible = true;
        }
      });
    },

    /**
     * 身份验证器绑定的方法
     * @author shuhua
     */
    fun_GoogleSuBmit() {
      // 身份验证码为空时
      if (!this.googleCode) {
        // 错误消息提示
        this.$alert("请输入身份验证码", "warning");
        return;
      }
      // 发起请求
      fun_PostAction("/userLogin/googleAuthenticatorVerify", {
        codes: this.googleCode,
        secretKey: this.secretKey
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 未绑定过谷歌身份验证器
          if (this.keyFlag === "1") {
            // 修改用户信息，绑定key值
            this.fun_SaveSecretKey();
          } else {
            // 登录成功添加token到vuex
            this.$store.commit("SET_TOKEN", this.user.token);
            this.$store.commit("SET_USERINFO", this.user.realName);
            this.$store.commit("SET_USERFLAG", this.user.userFlag);
            this.$store.commit("SET_PROJECT", "brs");
            // 跳往首页
            this.$router.push({
              path: "/home"
            });
          }
        } else {
          // 错误消息提示
          this.$alert(msg, "error");
          return;
        }
      });
    },

    /**
     * 保存谷歌身份验证码key值
     * @author shuhua
     */
    fun_SaveSecretKey() {
      // 发起请求
      fun_PostAction("/userLogin/saveSecretKey", {
        id: this.user.id,
        secretKey: this.secretKey
      }).then(res => {
        // 解构res.data
        const { result } = res.data;
        // 操作成功
        if (result) {
          // 关闭身份验证器绑定弹窗
          this.dialogVisible = false;
          // 登录成功添加token到vuex
          this.$store.commit("SET_TOKEN", this.user.token);
          this.$store.commit("SET_USERINFO", this.user.realName);
          this.$store.commit("SET_USERFLAG", this.user.userFlag);
          this.$store.commit("SET_PROJECT", "brs");
          // 跳往首页
          this.$router.push({
            path: "/home"
          });
        } else {
          this.$alert("绑定失败", "error");
          return;
        }
      });
    }
  }
};
